import React from 'react'
import { Tab } from 'semantic-ui-react'

import Order from './OrderByRegion'

export default ({ regions }) => (
  <Tab.Pane attached={false}>
    {
      regions.map(region => (
        <Order region={region} />
      ))
    }
  </Tab.Pane>
)



// WEBPACK FOOTER //
// ./src/containers/configurations/Order/index.js